// The rail SPARKLINE (prototype app.js spark()): a small area+line over one Metric's recorded series with
// the newest point marked. Renders ONLY the projection's recorded values (P-SELF — with fewer than two
// points there is nothing to chart and the component renders nothing). Colours come from the governed
// tokens exactly as the prototype's SVG did (G-181).

import type { MetricPoint } from '../projections.ts';

const W = 100;
const H = 32;
const PAD = 4;

/** The mini trend of one Metric's recorded values (prototype .mm-spark > .spark). */
export function Sparkline({
  series,
}: {
  readonly series: readonly MetricPoint[];
}): React.JSX.Element | null {
  if (series.length < 2) return null;
  const values = series.map((point) => point.value);
  const min = Math.min(...values);
  const span = Math.max(...values) - min || 1;
  const points = values.map((value, index) => {
    const x = PAD + (index / (values.length - 1)) * (W - PAD * 2);
    const y = PAD + (1 - (value - min) / span) * (H - PAD * 2);
    return [x, y] as const;
  });
  const line = points.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const area = `${PAD},${H - PAD} ${line} ${W - PAD},${H - PAD}`;
  const [endX, endY] = points[points.length - 1]!;
  return (
    <svg className="spark" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" aria-hidden="true">
      <polygon points={area} fill="var(--sage-tint)" stroke="none" />
      <polyline
        points={line}
        fill="none"
        stroke="var(--sage)"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={endX.toFixed(1)} cy={endY.toFixed(1)} r={2} fill="var(--forest)" stroke="none" />
    </svg>
  );
}
